import request from '@/utils/request'
import store from '@/store'
import { workbenchServiceDict } from '@/dictionary/system'
/** *************招标采购******************** */
const baseUrl = process.env.VUE_APP_PURCHASE_API

function getPlatformAlias() {
  return workbenchServiceDict.array.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

// 分页查询供应商招募
export function getRecruitListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/recruit-orders',
    method: 'get',
    params
  })
}

// 查询招募单
export function getRecruitOrderApi(params) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/${params.orderId}`,
    method: 'get'
  })
}

// 新增保存招募单
export function addRecruitOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders`,
    method: 'post',
    data
  })
}

// 修改保存的招募单
export function updateRecruitOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/${data.orderId}`,
    method: 'put',
    data
  })
}

// 直接发布招募单
export function publishRecruitOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/publish`,
    method: 'post',
    data
  })
}

// 发布保存的招募单
export function publishSaveRecruitOrderApi(data) {
  return request({
    url:
      baseUrl + `/workbench/purchaser/recruit-orders/${data.orderId}/publish`,
    method: 'put',
    data
  })
}

// 删除招募单
export function deleteRecruitOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/${data.orderId}/delete`,
    method: 'delete'
  })
}

// 获取供应商应募列表
export function getRecruitSupplierApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/recruit-orders/${params.orderId}/trades/page`,
    method: 'get',
    params
  })
}

// 下载响应资料
export function downloadAllApplyCertApi(query) {
  const alias = getPlatformAlias()
  const requireType =
    query.requireType || query.requireType === 0 ? query.requireType : ''
  return (
    baseUrl +
    `/workbench/purchaser/recruit-orders/${query.orderId}/trades/${query.tradeId}/down-apply-file?identity=${alias}&requireType=${requireType}`
  )
}

// 下载供应商招募所有已入库的供应商列表
export function downloadAllRecruitSupplierApi(query) {
  const alias = getPlatformAlias()
  return (
    baseUrl +
    `/workbench/purchaser/recruit-orders/${query.orderId}/trades/down?identity=${alias}`
  )
}

// 查询应募交易详情
export function getRecruitOrderTradeApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/recruit-orders/${params.orderId}/trades/${params.tradeId}/detail`,
    method: 'get'
  })
}

// 查询应募交易详情
export function auditRecruitOrderTradeApi(data) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/recruit-orders/${data.orderId}/trades/${data.tradeId}/approval`,
    method: 'put',
    data
  })
}

// 查询应募交易详情
export function changeRecruitOrderApi(data) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/${data.orderId}/change`,
    method: 'put',
    data
  })
}

// 查询供应商招募的审核列表
export function getRecruitAuditListApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/recruit-orders/${params.orderId}/trades/${params.tradeId}/approvals`,
    method: 'get'
  })
}

// 批量导入供应商招募的供应商
export function importRecruitSupplierApi(data) {
  return request(
    {
      url: baseUrl + '/workbench/template/materiel-recruit/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

/** *****************投标******************* */
// 查询招募单详情
export function getSupplierRecruitOrderApi(orderId) {
  return request({
    url: baseUrl + `/workbench/supplier/recruit-orders/${orderId}/detail`,
    method: 'get'
  })
}

// 查询供应商交易信息
export function getRecruitTradeApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/recruit-orders/${params.orderId}/trades/${params.tradeId}`,
    method: 'get'
  })
}

// 交易活动-提交应募响应
export function applyRecruitTradeApi(data, orderId) {
  return request({
    url: baseUrl + `/workbench/supplier/recruit-orders/${orderId}/trades/apply`,
    method: 'post',
    data
  })
}

// 交易活动-修改应募响应
export function applyRecruitTradeChangeApi(data, orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/recruit-orders/${orderId}/trades/${tradeId}/apply`,
    method: 'put',
    data
  })
}

// 服务费下单
export function createRecruitServerApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/recruit-orders/${orderId}/trades/${tradeId}/service-fee-order`,
    method: 'post'
  })
}

// 服务费下单
export function renewRecruitServerApi(srmPaymentId, supplierId) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/recruit-orders/${srmPaymentId}/srmSupplier/${supplierId}/service-fee-order`,
    method: 'post'
  })
}

// 修改供应商招募项目协助人
export function steRecruitAssistApi(data, orderId) {
  return request({
    url: baseUrl + `/workbench/purchaser/recruit-orders/${orderId}/assist`,
    method: 'put',
    data
  })
}
